import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false,
    key: null,
    requestId: null
};
var getAddressSubdistrictSlice = createSlice({
    name: "getAddressSubdistrict",
    initialState: initialState,
    reducers: {
        fetchData: function(state, param) {
            var payload = param.payload;
            state.data = null;
            state.isFetching = true;
            state.isError = false;
            state.key = payload.key;
            state.requestId = payload.requestId;
        },
        fetchDataSuccess: function(state, param) {
            var payload = param.payload;
            if (state.requestId !== payload.requestId) return;
            state.data = payload.data;
            state.isFetching = false;
        },
        fetchDataFailure: function(state, param) {
            var payload = param.payload;
            if (state.requestId !== payload.requestId) return;
            state.isFetching = false;
            state.isError = true;
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAddressSubdistrictSlice_actions = getAddressSubdistrictSlice.actions;
export var fetchData = _getAddressSubdistrictSlice_actions.fetchData, fetchDataSuccess = _getAddressSubdistrictSlice_actions.fetchDataSuccess, fetchDataFailure = _getAddressSubdistrictSlice_actions.fetchDataFailure, resetState = _getAddressSubdistrictSlice_actions.resetState;
export default getAddressSubdistrictSlice.reducer;
